import * as Yup from "yup";

import {
  TAccountTypeGeorgia,
  TAdditionalInfoGeorgia,
  TContactInfoCompanyGeorgia,
  TContactInfoGeorgia,
  TPasswordGeorgia,
} from "@/types/registrationGe.types";
import { AccountType } from "@/enums/registrationSteps.enum";

export const accountTypeSchemaGe: Yup.ObjectSchema<TAccountTypeGeorgia> =
  Yup.object().shape({
    accountType: Yup.mixed<AccountType>()
      .oneOf(
        Object.values(AccountType),
        'Account type must be either "private" or "business"',
      )
      .required("Account type is required"),
  });

export const contactInfoSchemaGe: Yup.ObjectSchema<TContactInfoGeorgia> =
  Yup.object().shape({
    email: Yup.string().matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: "validations_email_invalid",
      excludeEmptyString: true,
    }),
    phone: Yup.string()
      .required("validations_phone")
      .test(
        "phone-length",
        "validations_phone_must_be_9_digits",
        function (value) {
          if (value.startsWith("+995")) {
            const phoneDigits = value.replace(/^\+995/, "").replace(/\s/g, "");
            return phoneDigits.length === 9;
          } else if (value.startsWith("+1")) {
            return true;
          }
          return false;
        },
      ),
    checkTerms: Yup.boolean()
      .required("validations_terms_conditions_required")
      .oneOf([true], "validations_terms_conditions_required"),
    promocode: Yup.string(),
    marketing: Yup.boolean(),
  });

export const contactInfoSchemaCompanyGe: Yup.ObjectSchema<TContactInfoCompanyGeorgia> =
  Yup.object().shape({
    email: Yup.string().matches(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, {
      message: "validations_email_invalid",
      excludeEmptyString: true,
    }),
    phone: Yup.string().required("validations_phone"),
    checkTerms: Yup.boolean()
      .required("validations_terms_conditions_required")
      .oneOf([true], "validations_terms_conditions_required"),
    promocode: Yup.string(),
  });

export const passwordSchemaGe: Yup.ObjectSchema<TPasswordGeorgia> =
  Yup.object().shape({
    password: Yup.string().required(),
  });

export const additionalInfoSchemaGe: Yup.ObjectSchema<TAdditionalInfoGeorgia> =
  Yup.object().shape({
    id: Yup.string().required("validations_card_id"),
    firstName: Yup.string()
      .matches(/^[ა-ჰ\s]+$/, "validations_first_name_georgian")
      .required("validations_first_name"),
    lastName: Yup.string()
      .matches(/^[ა-ჰ\s]+$/, "validations_first_name_georgian")
      .required("validations_last_name"),
    cityId: Yup.object()
      .shape({
        id: Yup.number().required("validations_city"),
        mainText: Yup.string(),
      })
      .required(),
    address: Yup.string().required("validations_address_required"),
  });
